import { RecordingIndicator } from '@/components/atoms/RecordingIndicator'
import { CustomMeetingControls } from '@/components/organisms/CustomMeetingControls/CustomMeetingControls'
import { MeetingVideoGrid } from '@/components/organisms/MeetingVideoGrid'
import { AppTemplate } from '@/components/templates/AppTemplate/AppTemplate'

type MeetingMobileProps = {
  isCameraPermissionDenied: boolean
  isMicrophonePermissionDenied: boolean
}

export function VideoMeetingMobile({ isCameraPermissionDenied, isMicrophonePermissionDenied }: MeetingMobileProps) {
  return (
    <AppTemplate className="bg-primary [&>div:last-child]:p-0 [&>div:last-child]:flex-none lg:hidden">
      <div className="w-full h-dvh flex flex-col">
        {/* Video area - all space except controls */}
        <div className="relative flex-1 min-h-0 overflow-hidden">
          <MeetingVideoGrid />
          <div className="absolute bottom-16 left-4">
            <RecordingIndicator />
          </div>
        </div>

        {/* Controls - fixed at bottom */}
        <div className="h-32 flex items-center justify-center bg-primary">
          <CustomMeetingControls
            isCameraPermissionDenied={isCameraPermissionDenied}
            isMicrophonePermissionDenied={isMicrophonePermissionDenied}
            mode="video"
          />
        </div>
      </div>
    </AppTemplate>
  )
}
